import React from 'react';
import { MdLock, MdClose, MdLogout } from 'react-icons/md';
import { BiDesktop } from 'react-icons/bi';
import { IoMdCall } from 'react-icons/io';
import { MdEmail } from 'react-icons/md';
import './NoWebAccess.css';
import { useNavigate } from 'react-router-dom';

const NoWebAccess = ({ 
    onContactSupport,
    onContactAdmin,
    onLogout,
    message, 
    currentPlan = "BASIC",
    planDetails = {},
    isOpen = true,
    onClose,
    showCloseButton = false,
    supportContact = {
        phone: "+91 1234567890",
        email: "support@example.com"
    }
}) => {

    const navigate = useNavigate()
    const handleContactSupport = () => {
        if (onContactSupport) {
            onContactSupport();
        }
    };

    const handleContactAdmin = () => {
        if (onContactAdmin) {
            onContactAdmin();
        }
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    const handleLogout = () => {
        if (onLogout) {
            onLogout();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="plan-permission-modal-overlay">
            <div className="plan-permission-modal">
                {/* Logout Icon - Top Right */}
                <button className="logout-icon-button" onClick={handleClose} title="Logout">
                      <MdClose />
                </button>

                <div className="icon-container">
                    <MdLock className="lock-icon" />
                    <BiDesktop className="desktop-icon" />
                    <div className="icon-circle"></div>
                </div>
                
                <h2 className="permission-title">Web Access Not Available</h2>
                
                <p className="permission-message">
                    {message || `Web access is not available in your current plan. Please contact your admin or support team to enable web access.`}
                </p>

                {/* Current Plan Details */}
                <div className="current-plan-card">
                    <h3 className="plan-card-title">Your Current Plan</h3>
                    <div className="plan-name-badge">{currentPlan}</div>
                    
                    {planDetails && Object.keys(planDetails).length > 0 && (
                        <div className="plan-details-list">
                            {Object.entries(planDetails).map(([key, value], index) => (
                                <div key={index} className="plan-detail-item">
                                    <span className="detail-key">{key}:</span>
                                    <span className="detail-value">{value}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Contact Buttons */}
                <div className="contact-buttons">
                    <button className="contact-button primary-contact" onClick={handleContactAdmin}>
                        <IoMdCall className="button-icon" />
                        Contact Admin
                    </button>
                    <button className="contact-button secondary-contact" onClick={handleContactSupport}>
                        <MdEmail className="button-icon" />
                        Contact Support
                    </button>
                </div>

                {/* Contact Information */}
                <div className="contact-info-section">
                    <p className="contact-info-title">Support Contact Details:</p>
                    <div className="contact-details">
                        <div className="contact-item">
                            <IoMdCall className="contact-icon" />
                            <a href={`tel:${supportContact.phone}`}>{supportContact.phone}</a>
                        </div>
                        <div className="contact-item">
                            <MdEmail className="contact-icon" />
                            <a href={`mailto:${supportContact.email}`}>{supportContact.email}</a>
                        </div>
                    </div>
                </div>

                                 <button className="secondary-button" onClick={()=>window.open("https://play.google.com/store/apps/details?id=com.transport360app&hl=en", "_blank")}>
                    Continue with Mobile App
                </button>
            </div>
        </div>
    );
};

export default NoWebAccess;